import React from "react";

import ResetPassword from "../components/reset-password";
import { useState, useEffect } from "react";
import LanguageSelector from "../components/language/LanguageSelector";

function Resetpassword(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };


  useEffect(() => {

    //window.location.replace (process.env.REACT_APP_SSO_SERVICE + "/login?redirect="+window.location.host);
  
    }, []);

  return (
    <>
      <div className="header-ct-right" style={{width: "100%", display: "flex", justifyContent: "flex-end", marginTop: "50px", paddingRight: "50px"}}>
        <LanguageSelector />
      </div>
      <ResetPassword />
    </>
  );
}

export default Resetpassword;
